module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid section"
  }, [_c('div', {
    staticClass: "row heading"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-9 text-right"
  }, [_c('div', {
    staticStyle: {
      "width": "250px",
      "display": "inline-block"
    }
  }, [_c('show-hide-cols', {
    attrs: {
      "cols": _vm.cols,
      "selected": _vm.filters.columns
    }
  })], 1), _vm._v(" "), _c('save-report'), _vm._v(" "), _c('save-chart', {
    attrs: {
      "xOpts": _vm.selectedColumnObj,
      "yOpts": _vm.selectedColumnObj,
      "fn": "userUsers",
      "filters": _vm.filters
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-light",
    on: {
      "click": function($event) {
        _vm.showAddAgent = true;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("  New Agent")]), _vm._v(" \n        "), _c('button', {
    staticClass: "btn btn-light",
    on: {
      "click": _vm.clearFilters
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v("  Clear Filters")]), _vm._v(" \n\n      "), _c('download', {
    attrs: {
      "fn": "accounts",
      "filters": _vm.filters,
      "cols": _vm.cols
    }
  }), _vm._v("\n        \n      "), _c('paginate', {
    attrs: {
      "page-count": _vm.num_pages,
      "initial-page": parseInt(_vm.filters.page - 1),
      "page-range": 1,
      "margin-pages": 1,
      "click-handler": _vm.paginateClick,
      "container-class": "pagination",
      "page-class": "page-item",
      "page-link-class": "page-link",
      "prev-class": "page-item",
      "prev-link-class": "page-link",
      "next-class": "page-item",
      "next-link-class": "page-link"
    }
  })], 1)]), _vm._v(" "), _c('full-table', {
    attrs: {
      "headerClass": "table-head",
      "filterClass": "table-filter table-subhead",
      "cols": _vm.cols,
      "data": _vm.tableData,
      "filterInputClass": "form-control",
      "filters": _vm.filters
    },
    on: {
      "filter": _vm.fetch
    },
    scopedSlots: {
      "total_mrc_filter": function(props) {
        return [_c('range-filter', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.filters.search.total_mrc),
            expression: "filters.search.total_mrc"
          }],
          attrs: {
            "label": "$"
          },
          domProps: {
            "value": (_vm.filters.search.total_mrc)
          },
          on: {
            "input": function($event) {
              _vm.filters.search.total_mrc = $event
            }
          }
        })]
      },
      "accounts_filter": function(props) {
        return [_c('range-filter', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.filters.search.accounts),
            expression: "filters.search.accounts"
          }],
          attrs: {
            "label": "$"
          },
          domProps: {
            "value": (_vm.filters.search.accounts)
          },
          on: {
            "input": function($event) {
              _vm.filters.search.accounts = $event
            }
          }
        })]
      },
      "accounts_data": function(props) {
        return [_c('router-link', {
          staticClass: "btn btn-light btn-sm",
          attrs: {
            "to": '/account-details?general_search=&account_status=%5B%5D&account_mrc=%5Bnull,null%5D&latest_comms=%5Bnull,null%5D&ink_date=%7B%22timeframe%22%3A%22%22,%22start%22%3A%22%22,%22end%22%3A%22%22,%22group%22%3A%22%22%7D&term_date=%7B%22timeframe%22%3A%22%22,%22start%22%3A%22%22,%22end%22%3A%22%22,%22group%22%3A%22%22%7D&subagents=%5B%22' + encodeURI(props.data.name) + '%22%5D&approved=%5B%5D&estimated_comms=%5Bnull,null%5D&term=%5Bnull,null%5D&expected_spiff=%5Bnull,null%5D&actual_spiff=%5Bnull,null%5D&actual_delta=%5Bnull,null%5D&off_expected=%5Bnull,null%5D&spiff_delta=%5Bnull,null%5D&telno=&telno_carriers=&name=&carrier_name=&telno_carrier=&columns=%5B%22ink_date%22,%22term%22,%22name%22,%22carrier_name%22,%22subagents%22%5D&sort=%5B%7B%22field%22%3A%22ink_date%22,%22dir%22%3A%22DESC%22%7D%5D&page=1&limit=25'
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link-square"
        }), _vm._v("  " + _vm._s(props.value))])]
      },
      "tags_filter": function(props) {
        return [_c('multi-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.filters.search.tags),
            expression: "filters.search.tags"
          }],
          attrs: {
            "size": "sm",
            "list": _vm.tags,
            "label": "name",
            "id": "name",
            "placeholder": "Filter By Tag"
          },
          domProps: {
            "value": (_vm.filters.search.tags)
          },
          on: {
            "input": function($event) {
              _vm.filters.search.tags = $event
            }
          }
        })]
      },
      "tags_data": function(props) {
        return [_c('div', [_c('button', {
          staticClass: "btn btn-light btn-sm",
          on: {
            "click": function($event) {
              _vm.fetchAgentTags(props.data.user_id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-tag"
        })])])]
      },
      "name_data": function(props) {
        return [(_vm.$canAccess(19, 1)) ? _c('router-link', {
          attrs: {
            "to": 'agents/' + props.data.user_id
          }
        }, [_vm._v(" " + _vm._s(props.value) + " ")]) : _c('span', [_vm._v(" " + _vm._s(props.value))])]
      },
      "total_mrc_data": function(props) {
        return [_vm._v("\n        " + _vm._s(_vm._f("formatMoney")(props.value)) + "\n    ")]
      },
      "first_deal_data": function(props) {
        return [_vm._v("\n          " + _vm._s(_vm._f("formatDate")(props.value)) + "\n      ")]
      },
      "last_deal_data": function(props) {
        return [_vm._v("\n          " + _vm._s(_vm._f("formatDate")(props.value)) + "\n      ")]
      }
    }
  }, [_vm._l((_vm.cols), function(col) {
    return (_vm.meta && _vm.meta[col.key]) ? _c('template', {
      slot: col.key + '_heading'
    }, [_c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.bottom",
        value: (_vm.metaValues(_vm.meta[col.key])),
        expression: "metaValues(meta[col.key])",
        modifiers: {
          "bottom": true
        }
      }]
    }, [_vm._v("\n              " + _vm._s(col.display) + "\n              "), _c('i', {
      staticClass: "fa fa-info-circle",
      staticStyle: {
        "font-size": "12px"
      }
    })])]) : _vm._e()
  }), _vm._v(" "), _c('pulse-loader', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "loading": _vm.loading,
      "color": "#5e9cd3"
    },
    slot: "loading"
  })], 2), _vm._v(" "), (_vm.showAddAgent) ? _c('modal', {
    attrs: {
      "size": "lg"
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('h3', {
    staticClass: "modal-title d-inline d-flex justify-content-start"
  }, [_vm._v("Add Agent")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-clear close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showAddAgent = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])]), _vm._v(" "), _c('add-agent', {
    on: {
      "close": function($event) {
        _vm.showAddAgent = false
      }
    },
    slot: "body"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showAgentTags) ? _c('modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "close": _vm.closeTagWindow
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('h3', {
    staticClass: "modal-title d-inline d-flex justify-content-start"
  }, [_vm._v("Agent Tags")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-clear close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showAgentTags = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])]), _vm._v(" "), _c('div', {
    slot: "body"
  }, _vm._l((_vm.selectedAgentTags), function(t) {
    return _c('div', {
      staticClass: "tag"
    }, [_vm._v("\n                " + _vm._s(t.name) + "\n            ")])
  }))]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-3"
  }, [_c('h2', [_vm._v("Agent Index")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4666e6a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/agents/AgentIndex.vue
// module id = 385
// module chunks = 0